export default __webpack_public_path__ + "static/media/HTP-10.fce58964.jpg";